import { Helmet } from "react-helmet";

const InventorySEO = ({ data }) => {
  if (!data) return null;

  const title = data?.meta_data_title
    ? data?.meta_data_title
    : data?.listing_title
    ? data?.listing_title
    : `${data?.model?.manufacturer?.name || ""} ${data?.model?.number || ""} ${
        data?.year ? `(${data.year})` : ""
      } ${data?.unit_number ? `UNIT #${data.unit_number}` : ""}`;
  const description = data?.meta_data_description
    ? data?.meta_data_description
    : `Used ${data?.model?.manufacturer?.name} ${data?.model?.number} ${
        data?.year || ""
      }. Unit: ${data?.unit_number}. Hours: ${
        data?.meter_hours || "N/A"
      }. Contact us for a condition report.`;
  const imageUrl = data?.primary_image?.url;
  const url = typeof window !== "undefined" ? window.location.href : "";
  console.log("data", data);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          name: title,
          image: imageUrl,
          description: description,
          brand: {
            "@type": "Brand",
            name: data?.model?.manufacturer?.name,
          },
          sku: data?.unit_number,
          url: url,
        })}
      </script>
    </Helmet>
  );
};

export default InventorySEO;
